import {Route} from 'entity-manager';

@Route('countries')

export class Country {
    protected id: string;

    protected code: string;

    protected name: string;

    public getId(): string | undefined {
        return this.id;
    }

    public setId(id: string): Country {
        this.id = id;
        return this;
    }

    public getCode(): string | undefined {
        return this.code;
    }

    public setCode(code: string): Country {
        this.code = code;
        return this;
    }

    public getName(): string | undefined {
        return this.name;
    }

    public setName(name: string): Country {
        this.name = name;
        return this;
    }
}
